import { render } from "./DialogSaveImage.vue?vue&type=template&id=c4ad989c&scoped=true"
import script from "./DialogSaveImage.vue?vue&type=script&lang=js"
export * from "./DialogSaveImage.vue?vue&type=script&lang=js"

import "./DialogSaveImage.vue?vue&type=style&index=0&id=c4ad989c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4ad989c"]])

export default __exports__